/**
 * Shell for the pages that belong to one course.
 *
 * A layout route rather than a tab strip copied into four pages: the nav then cannot drift
 * between them, and switching tabs does not remount it, so it never flickers.
 *
 * The unit page is deliberately NOT nested here. It sits a level deeper and carries its
 * own breadcrumb back through subsection and section, and showing course-level tabs above
 * that would imply the unit is a sibling of "Grading" rather than content inside the
 * outline.
 */

import { NavLink, Outlet, useParams } from 'react-router-dom';
import { Icon } from '../../shared/ui';
import './course-layout.css';

const TABS: { to: string; label: string; icon: string; end: boolean }[] = [
  { to: '', label: 'Outline', icon: 'account_tree', end: true },
  { to: 'settings', label: 'Schedule & details', icon: 'event', end: false },
  { to: 'grading', label: 'Grading', icon: 'grading', end: false },
  { to: 'certificates', label: 'Certificates', icon: 'workspace_premium', end: false },
];

export function CourseLayout() {
  const { courseId = '' } = useParams();
  const base = `/admin/courses/${encodeURIComponent(courseId)}`;

  return (
    <>
      <nav className="course-nav" aria-label="Course sections">
        <NavLink to="/admin/courses" className="course-nav__back">
          <Icon name="arrow_back" />
          All courses
        </NavLink>
        <div className="course-nav__tabs">
          {TABS.map((tab) => (
            <NavLink
              key={tab.to}
              // `end` only on the outline: without it the index tab stays highlighted on
              // every child route, so two tabs look active at once.
              end={tab.end}
              to={tab.to ? `${base}/${tab.to}` : base}
              className={({ isActive }) => `course-nav__tab${isActive ? ' is-active' : ''}`}
            >
              <Icon name={tab.icon} />
              {tab.label}
            </NavLink>
          ))}
        </div>
      </nav>
      <Outlet />
    </>
  );
}
